export default "__VITE_ASSET__CDR6D1Rl__"